var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHillside(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "apartmentBuilding",
    viewBox: "0 0 300 400",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "sky",
    className: "day-night-darker",
    width: 300,
    height: 400,
    fill: "#85c8f2",
    style: {
      paintOrder: "normal"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "hillLeft",
    className: "day-night-darker",
    d: "m233.92 356.64-85.442 43.339-148.18 0.0204l0.0088-23.693c59.693-64.34 254-64.346 254-64.346",
    fill: "#267302"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "hillRight",
    className: "day-night-darker",
    d: "m152.03 368.4-0.17123 31.577 147.8 0.0204 0.0512-91.536c-145.63 5.21-159.85 18.026-159.85 18.026",
    fill: "#267302"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "building",
    className: "day-night",
    d: "m245.37 383.19c0 2.6623-2.137 4.8204-4.767 4.8204h-181.2c-2.6257 0-4.767-2.1581-4.767-4.8204v-250.22c0-2.6674 2.142-4.8255 4.767-4.8255h181.2c2.63 0 4.767 2.1581 4.767 4.8255z",
    fill: "#d9dbbd",
    strokeWidth: 0.63033
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "buildingShadow",
    className: "day-night",
    d: "m182 388.03h58.764c2.63 0 4.767-2.1581 4.767-4.8204v-250.22c0-2.6674-2.137-4.8255-4.767-4.8255h-181.2c-2.6256 0-4.767 2.1581-4.767 4.8255v12.039z",
    fill: "#898c66",
    strokeWidth: 0.63033
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "roof",
    className: "day-night",
    d: "m270.3 132.69-115.25-50.648c-2.6845-2.7175-7.4321-2.7175-10.112 0l-115.24 50.648c-2.043 2.063-2.6695 5.18-1.5543 7.8828 1.1102 2.7073 3.7158 4.476 6.6077 4.476h230.51c2.8869 0 5.4925-1.7681 6.5976-4.476 1.1008-2.7029 0.48867-5.8199-1.5594-7.8828z",
    fill: "#7d5c3c",
    strokeWidth: 0.63033
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "roofShadow",
    className: "day-night",
    d: "m270.3 132.69-115.25-50.648c-2.6845-2.7175-7.4321-2.7175-10.112 0l-91.193 50.648c-2.048 2.063-2.6651 5.18-1.5493 7.8828 1.1008 2.7073 3.7107 4.476 6.6127 4.476h206.45c2.8869 0 5.4925-1.7681 6.5976-4.476 1.1008-2.7029 0.48867-5.8199-1.5594-7.8828z",
    fill: "#4d3825",
    strokeWidth: 0.63033
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "roomBackground",
    d: "m106.36 202.38c0 2.7625-2.2059 4.9954-4.9349 4.9954h-8.2215c-2.719 0-4.9349-2.2329-4.9349-4.9954v-24.977c0-2.7625 2.2159-4.9954 4.9349-4.9954h8.2215c2.729 0 4.9349 2.2329 4.9349 4.9954z",
    fill: "#7c7f73",
    strokeWidth: 0.63033
  })), /*#__PURE__*/React.createElement("path", {
    id: "monitor",
    d: "m90.571 190.9h13.477c0.67337 0 1.2154 0.65847 1.2154 1.4764v8.12c0 0.8179-0.54207 1.4764-1.2154 1.4764h-13.477c-0.67336 0-1.2154-0.65847-1.2154-1.4764v-8.12c0-0.8179 0.54208-1.4764 1.2154-1.4764z",
    fill: "#646464",
    strokeWidth: 0.63033,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "monitorStand",
    d: "m96.461 199.09h1.7048v5.3615h-1.7048z",
    fill: "#272727",
    strokeWidth: 0.63033,
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "monitorBack",
    d: "m95.941 195.44h2.7406c0.34707 0 0.62649 0.28285 0.62649 0.63417v3.0736c0 0.35132-0.27942 0.63417-0.62649 0.63417h-2.7406c-0.34708 0-0.6265-0.28285-0.6265-0.63417v-3.0736c0-0.35132 0.27942-0.63417 0.6265-0.63417z",
    fill: "#444444",
    strokeWidth: 0.63033,
    style: {
      paintOrder: "normal"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "curtains",
    fill: "#454633"
  }, /*#__PURE__*/React.createElement("path", {
    id: "leftCurtain",
    className: "day-night",
    d: "m93.62 172.32c-2.9594 0-5.3521 2.2336-5.3521 4.9961v24.977c0 2.7625 2.3928 4.9961 5.3521 4.9961h4.4075v-34.969z",
    strokeWidth: 0.65639
  }), /*#__PURE__*/React.createElement("path", {
    id: "rightCurtain",
    className: "day-night",
    d: "m101.19 172.32c2.9018 0 5.2481 2.2336 5.2481 4.9961v24.977c0 2.7625-2.3463 4.9961-5.2481 4.9961h-4.3218v-34.969z",
    strokeWidth: 0.64998
  }), /*#__PURE__*/React.createElement("path", {
    className: "day-night",
    d: "m158.59 202.38c0 2.7625-2.2159 4.9954-4.9349 4.9954h-8.2215c-2.729 0-4.9349-2.2329-4.9349-4.9954v-24.977c0-2.7625 2.2059-4.9954 4.9349-4.9954h8.2215c2.719 0 4.9349 2.2329 4.9349 4.9954z",
    strokeWidth: 0.63033
  }), /*#__PURE__*/React.createElement("path", {
    className: "day-night",
    d: "m210.81 202.38c0 2.7625-2.2059 4.9954-4.9349 4.9954h-8.2215c-2.719 0-4.9349-2.2329-4.9349-4.9954v-24.977c0-2.7625 2.2159-4.9954 4.9349-4.9954h8.2215c2.729 0 4.9349 2.2329 4.9349 4.9954z",
    strokeWidth: 0.63033
  }), /*#__PURE__*/React.createElement("path", {
    className: "day-night",
    d: "m106.36 266.08c0 2.7625-2.2059 4.9954-4.9349 4.9954h-8.2215c-2.719 0-4.9349-2.233-4.9349-4.9954v-24.977c0-2.7625 2.2159-4.9954 4.9349-4.9954h8.2215c2.729 0 4.9349 2.2329 4.9349 4.9954z",
    strokeWidth: 0.63033
  }), /*#__PURE__*/React.createElement("path", {
    className: "day-night",
    d: "m158.59 266.08c0 2.7625-2.2159 4.9954-4.9349 4.9954h-8.2215c-2.729 0-4.9349-2.233-4.9349-4.9954v-24.977c0-2.7625 2.2059-4.9954 4.9349-4.9954h8.2215c2.719 0 4.9349 2.2329 4.9349 4.9954z",
    strokeWidth: 0.63033
  }), /*#__PURE__*/React.createElement("path", {
    className: "day-night",
    d: "m210.81 266.08c0 2.7625-2.2059 4.9954-4.9349 4.9954h-8.2215c-2.719 0-4.9349-2.233-4.9349-4.9954v-24.977c0-2.7625 2.2159-4.9954 4.9349-4.9954h8.2215c2.729 0 4.9349 2.2329 4.9349 4.9954z",
    strokeWidth: 0.63033
  }), /*#__PURE__*/React.createElement("path", {
    className: "day-night",
    d: "m106.36 329.77c0 2.7625-2.2059 4.9954-4.9349 4.9954h-8.2215c-2.719 0-4.9349-2.2329-4.9349-4.9954v-24.977c0-2.7625 2.2159-4.9954 4.9349-4.9954h8.2215c2.729 0 4.9349 2.2329 4.9349 4.9954z",
    strokeWidth: 0.63033
  }), /*#__PURE__*/React.createElement("path", {
    className: "day-night",
    d: "m158.59 329.77c0 2.7625-2.2159 4.9954-4.9349 4.9954h-8.2215c-2.729 0-4.9349-2.2329-4.9349-4.9954v-24.977c0-2.7625 2.2059-4.9954 4.9349-4.9954h8.2215c2.719 0 4.9349 2.2329 4.9349 4.9954z",
    strokeWidth: 0.63033
  }), /*#__PURE__*/React.createElement("path", {
    className: "day-night",
    d: "m210.81 329.77c0 2.7625-2.2059 4.9954-4.9349 4.9954h-8.2215c-2.719 0-4.9349-2.2329-4.9349-4.9954v-24.977c0-2.7625 2.2159-4.9954 4.9349-4.9954h8.2215c2.729 0 4.9349 2.2329 4.9349 4.9954z",
    strokeWidth: 0.63033
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "windowsills",
    fill: "#674c31",
    strokeWidth: 0.63033
  }, /*#__PURE__*/React.createElement("path", {
    className: "day-night",
    d: "m113.66 205.77c0 1.6387-1.3125 2.9673-2.9314 2.9673h-25.908c-1.6189 0-2.9314-1.3286-2.9314-2.9673s1.3125-2.9673 2.9314-2.9673h25.908c1.6239 0 2.9314 1.3242 2.9314 2.9673z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "day-night",
    d: "m165.88 205.77c0 1.6387-1.3125 2.9673-2.9314 2.9673h-25.908c-1.6189 0-2.9314-1.3286-2.9314-2.9673s1.3125-2.9673 2.9314-2.9673h25.908c1.6232 0 2.9314 1.3242 2.9314 2.9673z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "day-night",
    d: "m218.11 205.77c0 1.6387-1.3125 2.9673-2.9314 2.9673h-25.908c-1.6189 0-2.9314-1.3286-2.9314-2.9673s1.3125-2.9673 2.9314-2.9673h25.908c1.6239 0 2.9314 1.3242 2.9314 2.9673z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "day-night",
    d: "m113.66 269.46c0 1.6387-1.3125 2.9673-2.9314 2.9673h-25.908c-1.6189 0-2.9314-1.3286-2.9314-2.9673 0-1.6387 1.3125-2.9673 2.9314-2.9673h25.908c1.6239 0 2.9314 1.3242 2.9314 2.9673z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "day-night",
    d: "m165.88 269.46c0 1.6387-1.3125 2.9673-2.9314 2.9673h-25.908c-1.6189 0-2.9314-1.3286-2.9314-2.9673 0-1.6387 1.3125-2.9673 2.9314-2.9673h25.908c1.6232 0 2.9314 1.3242 2.9314 2.9673z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "day-night",
    d: "m218.11 269.46c0 1.6387-1.3125 2.9673-2.9314 2.9673h-25.908c-1.6189 0-2.9314-1.3286-2.9314-2.9673 0-1.6387 1.3125-2.9673 2.9314-2.9673h25.908c1.6239 0 2.9314 1.3242 2.9314 2.9673z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "day-night",
    d: "m113.66 333.15c0 1.6387-1.3125 2.9673-2.9314 2.9673h-25.908c-1.6189 0-2.9314-1.3286-2.9314-2.9673 0-1.6387 1.3125-2.9673 2.9314-2.9673h25.908c1.6239 0 2.9314 1.3235 2.9314 2.9673z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "day-night",
    d: "m165.88 333.15c0 1.6387-1.3125 2.9673-2.9314 2.9673h-25.908c-1.6189 0-2.9314-1.3286-2.9314-2.9673 0-1.6387 1.3125-2.9673 2.9314-2.9673h25.908c1.6232 0 2.9314 1.3235 2.9314 2.9673z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "day-night",
    d: "m218.11 333.15c0 1.6387-1.3125 2.9673-2.9314 2.9673h-25.908c-1.6189 0-2.9314-1.3286-2.9314-2.9673 0-1.6387 1.3125-2.9673 2.9314-2.9673h25.908c1.6239 0 2.9314 1.3235 2.9314 2.9673z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "foundation",
    className: "day-night",
    d: "m252.28 394c0 3.3168-2.6601 5.9993-5.9267 5.9993h-192.71c-3.2716 0-5.9267-2.6826-5.9267-5.9993v-3.0022c0-3.3168 2.6551-6.0044 5.9267-6.0044h192.71c3.2672 0 5.9267 2.6876 5.9267 6.0044z",
    fill: "#4d3825",
    strokeWidth: 0.63033
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "frontDoor",
    className: "day-night",
    d: "m158.59 393.46c0 2.7625-2.2159 4.9954-4.9349 4.9954h-8.2215c-2.729 0-4.9349-2.233-4.9349-4.9954v-24.977c0-2.7625 2.2059-4.9954 4.9349-4.9954h8.2215c2.719 0 4.9349 2.2329 4.9349 4.9954z",
    fill: "#454633",
    strokeWidth: 0.63033
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "frontStep",
    className: "day-night",
    d: "m165.88 397.03c0 1.6387-1.3125 2.9673-2.9314 2.9673h-25.908c-1.6189 0-2.9314-1.3286-2.9314-2.9673 0-1.6387 1.3125-2.9673 2.9314-2.9673h25.908c1.6232 0 2.9314 1.3235 2.9314 2.9673z",
    fill: "#71725d",
    strokeWidth: 0.63033
  })), /*#__PURE__*/React.createElement("g", {
    id: "stars",
    fill: "#f5f4df"
  }, /*#__PURE__*/React.createElement("path", {
    className: "hillside-star",
    transform: "matrix(.57078 .089507 -.089507 .57078 115.09 33.192)",
    d: "m262.39 90.919-3.9048-3.1573-1.0844 4.903 0.0339-5.0214-4.5094 2.2092 3.947-3.1043-4.5388-2.1482 4.888 1.1504-1.1504-4.888 2.1482 4.5388 3.1043-3.947-2.2092 4.5094 5.0214-0.03386-4.903 1.0844z",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "hillside-star",
    d: "m21.6 181.02-3.5281-2.8527-0.97977 4.4301 0.03059-4.5371-4.0745 1.9961 3.5663-2.8049-4.101-1.941 4.4165 1.0394-1.0394-4.4165 1.941 4.101 2.8049-3.5663-1.9961 4.0745 4.5371-0.0306-4.4301 0.97977z",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "hillside-star",
    d: "m288.95 167.19-3.9048-3.1573-1.0844 4.903 0.0339-5.0214-4.5094 2.2092 3.947-3.1043-4.5388-2.1482 4.888 1.1504-1.1504-4.888 2.1482 4.5388 3.1043-3.947-2.2092 4.5094 5.0214-0.0339-4.903 1.0844z",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "hillside-star",
    d: "m284.91 97.842-2.9004-2.3452-0.80545 3.6419 0.0251-3.7298-3.3496 1.641 2.9318-2.3058-3.3714-1.5957 3.6307 0.85448-0.85448-3.6307 1.5957 3.3714 2.3058-2.9318-1.641 3.3495 3.7298-0.02515-3.6419 0.80545z",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "hillside-star",
    transform: "matrix(.74816 -.42436 .42436 .74816 14.363 112.13)",
    d: "m214.68 93.295-4.5325-3.6648-1.2587 5.6912 0.0393-5.8286-5.2344 2.5644 4.5815-3.6034-5.2684-2.4935 5.6737 1.3353-1.3353-5.6737 2.4935 5.2685 3.6034-4.5815-2.5644 5.2344 5.8286-0.0393-5.6912 1.2587z",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "hillside-star",
    d: "m48.782 92.179-2.3982-1.9391-0.66599 3.0113 0.02079-3.084-2.7696 1.3568 2.4242-1.9066-2.7876-1.3194 3.0021 0.70654-0.70654-3.0021 1.3194 2.7876 1.9066-2.4242-1.3568 2.7696 3.084-0.02079-3.0113 0.66599z",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "hillside-star",
    d: "m111.86 86.099-3.6537-2.9542-1.0146 4.5877 0.0317-4.6985-4.2195 2.0671 3.6932-2.9047-4.247-2.0101 4.5736 1.0764-1.0764-4.5736 2.0101 4.2469 2.9047-3.6932-2.0672 4.2195 4.6985-0.03168-4.5878 1.0146z",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "hillside-star",
    transform: "rotate(-44.878 17.884 104.83)",
    d: "m22.191 109.13-3.9048-3.1572-1.0844 4.903 0.03385-5.0214-4.5094 2.2092 3.947-3.1043-4.5388-2.1482 4.888 1.1504-1.1504-4.888 2.1482 4.5388 3.1043-3.947-2.2092 4.5094 5.0214-0.0339-4.903 1.0844z",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "hillside-star",
    d: "m268.6 250.43-1.8961-1.5331-0.52653 2.3808 0.0164-2.4383-2.1897 1.0727 1.9166-1.5074-2.2039-1.0431 2.3735 0.55859-0.55859-2.3735 1.0431 2.2039 1.5074-1.9166-1.0727 2.1897 2.4382-0.0164-2.3808 0.52654z",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "hillside-star",
    transform: "rotate(-21.055 275.4 220.05)",
    d: "m278.19 222.83-2.5238-2.0406-0.70085 3.169 0.0219-3.2455-2.9146 1.4279 2.5511-2.0064-2.9336-1.3884 3.1592 0.74352-0.74353-3.1592 1.3884 2.9336 2.0064-2.5511-1.4279 2.9146 3.2455-0.0219-3.169 0.70086z",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "hillside-star",
    d: "m25.085 271.02-2.5238-2.0406-0.70086 3.169 0.02188-3.2455-2.9146 1.4279 2.5511-2.0064-2.9336-1.3884 3.1592 0.74353-0.74352-3.1592 1.3884 2.9336 2.0064-2.5511-1.4279 2.9146 3.2455-0.0219-3.169 0.70085z",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "hillside-star",
    transform: "matrix(.72138 .21437 -.21437 .72138 67.454 44.399)",
    d: "m34.192 240.29-2.5238-2.0406-0.70086 3.169 0.02188-3.2455-2.9146 1.4279 2.5511-2.0064-2.9336-1.3884 3.1592 0.74352-0.74352-3.1592 1.3884 2.9336 2.0064-2.5511-1.4279 2.9146 3.2455-0.0219-3.169 0.70086z",
    style: {
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    id: "textArea",
    x: -0.055198,
    y: 0.4448,
    width: 300.11,
    height: 79.11,
    fill: "none",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "textElement",
    fill: "#ffffff",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    "aria-label": "hillside"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m51.549 69.824h-6.512v-26.245q0-14.011-12.432-14.011-3.3547 0-6.9067 1.776-3.552 1.6773-5.2293 4.144v34.336h-6.6107v-60.187l6.6107-3.4533v23.581q6.1173-5.92 14.208-5.92 16.872 0 16.872 19.24z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m73.473 25.03v44.795h-6.512v-44.795zm-7.4987-14.603q0-1.6773 1.2827-2.96 1.2827-1.2827 3.0587-1.2827t3.0587 1.2827q1.2827 1.2827 1.2827 2.96 0 1.8747-1.2827 3.1573-1.2827 1.184-3.0587 1.184-1.8747 0-3.1573-1.184-1.184-1.2827-1.184-3.1573z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m96.011 6.1842v63.64h-6.6107v-60.088z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m117.98 6.1842v63.64h-6.6107v-60.088z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m156.82 31.739q-4.9333-2.5653-10.755-2.5653-3.9467 0-6.216 1.776-2.1707 1.6773-2.1707 4.6373 0 3.1573 1.9733 4.9333 2.072 1.6773 7.7947 3.3547 8.0907 2.4667 11.248 5.5253 3.1573 3.0587 3.1573 8.584 0 5.8213-4.44 9.472-4.3413 3.552-11.248 3.552-9.0773 0-15.787-4.9333 0.296-0.49333 0.98666-1.6773 0.69067-1.2827 1.184-1.9733 5.7227 3.1573 12.333 3.1573 10.36 0 10.36-7.7947 0-3.1573-2.2693-4.9333-2.1707-1.776-8.1893-3.3547-14.011-3.9467-14.011-13.715 0-5.2293 4.0453-8.584 4.144-3.3547 10.557-3.3547 7.5973 0 13.616 4.2427z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m181.2 25.03v44.795h-6.512v-44.795zm-7.4987-14.603q0-1.6773 1.2827-2.96 1.2827-1.2827 3.0587-1.2827t3.0587 1.2827q1.2827 1.2827 1.2827 2.96 0 1.8747-1.2827 3.1573-1.2827 1.184-3.0587 1.184-1.8747 0-3.1573-1.184-1.184-1.2827-1.184-3.1573z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m229.39 69.824-1.0853-4.736q-4.736 5.92-13.715 5.92-9.768 0-15.491-7.3013-4.9333-6.3147-4.9333-15.688 0-11.84 6.9067-18.549 5.7227-5.624 14.109-5.624 7.8933 0 12.629 5.2293v-19.141l6.512-3.6507v63.541zm-1.5787-11.939v-21.411q-1.2827-3.0587-4.6373-5.1307-3.3547-2.1707-7.104-2.1707-6.512 0-10.656 5.1307-4.144 5.032-4.144 13.024 0 9.0773 4.5387 14.109 3.9467 4.144 9.8667 4.144 3.9467 0 7.2027-2.072 3.3547-2.1707 4.9333-5.624z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m286.14 49.696h-31.968q0.39467 7.2027 4.9333 11.544 4.6373 4.3413 11.939 4.3413 6.1173 0 11.939-3.6507l2.2693 3.9467q-6.512 5.1307-15.688 5.1307-10.656 0-16.971-7.0053-5.8213-6.3147-5.8213-16.379 0-10.459 6.216-17.464 5.624-6.3147 13.912-6.3147 9.9653 0 15.195 8.0907 4.0453 6.3147 4.0453 15.589zm-32.067-5.328h25.259q-0.296-7.2027-3.552-11.248-3.1573-4.0453-8.7813-4.0453-5.328 0-8.9787 4.2427-3.552 4.2427-3.9467 11.051z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHillside);
export default __webpack_public_path__ + "static/media/hillside.b78afc81.svg";
export { ForwardRef as ReactComponent };